import React, { useContext } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

import { useInput } from "../../../../../hooks/useInput";
import { Spinner } from "../../../../../components/Spinner";
import { useOnChange } from "../../../../../hooks/useOnChange";
import { InputText } from "../../../../../components/InputText";
import { EntryContext } from "../../../../../contexts/EntryContext";

const PlanItemStyle = styled.div`
    >div:nth-child(1) {
        margin-bottom: 10px;
    }
    >div:nth-child(2) {
        gap: 8px;
        display: grid;
        align-items: flex-end;
        grid-template-columns: repeat(4, 1fr);
    }
`;

export const PlanItem = props => {
    const { plot, plan, index } = props;

    const inputName = "plan-" + index;
    const plansLayer = "plansLayer";

    const entryContext = useContext(EntryContext);
    const { entry } = entryContext;

    const name = useInput(inputName + "-name", plan.layerName);
    const opacity = useInput(inputName + "-opacity", plan.opacity);
    const rotationAngle = useInput(inputName + "-rotationAngle", plan.rotationAngle);

    useOnChange((name, value) => {
        plan.layerName = value;
        entryContext.setEntry(entry);
    }, [name]);

    useOnChange((name, value) => {
        plan.opacity = value;
        entryContext.setEntry(entry);
        const image = getImageForIndex(index);
        if (image !== undefined) {
            image.set({ opacity: value / 10 });
            plot.canvas.renderAll();
        }
    }, [opacity]);

    useOnChange((name, value) => {
        const image = getImageForIndex(index);
        if (image !== undefined) {
            image.rotate(value);
            props.onModify(index, image.left, image.top, value);
            plot.canvas.renderAll();
        }
    }, [rotationAngle]);

    const getImageForIndex = index => {
        const layer = plot.getLayer(plansLayer);
        const images = layer.getObjects();
        return images.find(image => image.index === index);
    };

    return (
        <PlanItemStyle>
            <div>
                <InputText {...name.bind}
                    maxLength="40"
                    title={intl.get("entry.plan.plans.name")} />
            </div>
            <div>
                <Spinner {...opacity.bind}
                    min={0}
                    max={10}
                    step={1}
                    title={intl.get("entry.plan.plans.opacity")} />
                <Spinner {...rotationAngle.bind}
                    min={0}
                    max={360}
                    step={1}
                    title={intl.get("entry.plan.plans.rotationAngle")} />
            </div>
        </PlanItemStyle>
    );
};